<template>
    <label class="radioSet py-3 h-100" v-bind:class="{'is-selected' : isSelected}">
        <div class="radioSet__body">
            <div>
                <div class="small-title mb-1">{{$t('components.SetRadioItemEmpty.selectMyself')}}</div>
                <p class="f-body">{{$t('components.SetRadioItemEmpty.selectMyselfUsageDescription')}}</p>
            </div>
            <div class="radioSet__image px-7">
                <img alt src="/images/svg/hand.svg"/>
            </div>
        </div>
    </label>
</template>

<script>
    export default {
        computed: {
            isSelected: function () {
                return this.$store.getters.isSelectedThisSet(0);
            }
        }
    };
</script>
